export const Links = {
  support: 'https://pitchhub.helpdocs.io/',
  policy: 'https://blog.pitchhub.com/support/notices/',
  blog: 'https://blog.pitchhub.com/',
  gettingStarted: 'https://pitchhub.helpdocs.io/article/iahfg7v3ev-teleprompter-introduction',
};
